// src/utils/api.js
import axios from "axios"

// Determine the base URL based on the environment
// In development, it's an empty string (assuming proxy is set up in package.json)
// In production, it uses SERVER_URL environment variable

const BASE_URL =
  process.env.NODE_ENV === "development" ? "" : process.env.REACT_APP_API_URL

console.log("BASE_URL", process.env)

const api = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
})

export default api
